// Site-wide configuration. Editable in one place.
export const SITE = {
  company: "Terraetrilhos.com",
  brand: "Terra & Trilhos",
  tagline: "Casa criativa de storytelling rural e aventura outdoor.",
  founderName: "Eduardo Moreira",
  founderRole: "Criador e gestor de conteúdo",
  email: "parcerias@terraetrilhos.com",
  city: "Aveiro, Portugal",
};

export const CHANNELS = [
  {
    slug: "viver-na-aldeia",
    name: "Viver na Aldeia",
    handle: "@ViverNaAldeia",
    url: "https://www.youtube.com/@ViverNaAldeia",
    accent: "#C47A4D",
    accentSoft: "rgba(196,122,77,0.15)",
    tagline: "Slow Living, Terra e Tradição Portuguesa.",
    description:
      "Bem-vindo ao Viver na Aldeia. Mais do que um canal, este é o registo real da nossa vida no Portugal profundo. Aqui, a recuperação de ruínas ganha vida através do DIY e restauro em pedra, enquanto a horta biológica e os animais ditam o ritmo dos nossos dias. Cada vídeo é um diário visual sobre a coragem de voltar à origem — aliando a sabedoria ancestral a uma estética cinematográfica moderna.",
    pillars: ["Slow Living", "Restauro Rural & DIY", "Cultura Portuguesa", "Horta & Autossuficiência"],
    audience: "Portugal · Brasil · Europa Ocidental · 25–55 anos",
    stats: { subscribers: "30.000+", views: "500.000", videos: "50" },
    community_label: "A Nossa Comunidade em Crescimento",
    image: "https://customer-assets.emergentagent.com/job_brand-portfolio-41/artifacts/6xwhfb1s_Gemini_Generated_Image_wenpvdwenpvdwenp.png",
    logo: "https://customer-assets.emergentagent.com/job_brand-portfolio-41/artifacts/9dhd7296_image-gen%20%282%29.png",
    // Vídeos com mais visualizações — Viver na Aldeia (ordenado por views)
    videos: [
      { id: "VwPEOhQLNsg", title: "Comprámos uma Quinta Abandonada por Apenas 100.000€! | Tour Completa" },
      { id: "8zgzwlkrCi0", title: "Comprar Janelas em Espanha Vale a Pena? A Minha Experiência Completa" },
      { id: "IWiuwMFBkkY", title: "O Apagão Chegou... Mas Nós Nunca Ficámos Sem Luz" },
      { id: "KvkRIf76Tys", title: "90% das pessoas falham nisto ao isolar o Sótão" },
      { id: "69qtME3rsAI", title: "Quanto gastamos para renovar toda a eletricidade da casa? Custos reais" },
      { id: "thS6BPLy_f0", title: "Acabei com as Infiltrações no Telhado de uma Vez por Todas! Passo a Passo" },
      { id: "ggfhuj_oVV0", title: "Um Casino Online Quis Patrocinar o Canal. Eu Disse Não" },
      { id: "jyLD-U0_VZU", title: "Transformei Esta Casa de Banho Antiga Sem Gastar uma Fortuna" },
    ],
  },
  {
    slug: "trilhos-em-furia",
    name: "Trilhos em Fúria",
    handle: "@trilhosemfuria",
    url: "https://www.youtube.com/@trilhosemfuria",
    accent: "#5C8041",
    accentSoft: "rgba(92,128,65,0.15)",
    tagline: "Exploração, Montanha e Trilhos em Estado Puro.",
    description:
      "No Trilhos em Fúria, a exploração não tem limites. Levamos-te pelos trilhos mais desafiantes e paisagens deslumbrantes de Portugal e do mundo — sempre a pé, com a mochila às costas e o espírito de aventura no máximo. De florestas ancestrais a cumes imponentes, cada vídeo é uma narrativa visual de superação e descoberta da natureza selvagem.",
    pillars: ["Hiking & Trekking de Montanha", "Exploração de Lugares Esquecidos", "Cinemática de Aventura & Drone", "História & Património Remoto"],
    audience: "Ibéria · Europa Central · 18–40 anos · 78% masculino",
    stats: { subscribers: "14.200+", views: "1.500.000", videos: "133" },
    community_label: "A Nossa Comunidade de Aventureiros",
    image: "https://customer-assets.emergentagent.com/job_brand-portfolio-41/artifacts/1bttsg3l_Gemini_Generated_Image_afm4wafm4wafm4wa.png",
    // Vídeos com mais visualizações — Trilhos em Fúria (ordenado por views)
    videos: [
      { id: "II7wYEW69EU", title: "Encontrei um Paraíso Perdido nas Montanhas de Portugal" },
      { id: "dMJv2LLBg3Y", title: "O que encontrei na aldeia mais isolada de Portugal (Assustador)" },
      { id: "an2ZIndyYJM", title: "O Hotel Radioativo de Portugal: Beberam Veneno por 30 Anos" },
      { id: "8PBqmKhHm5c", title: "A Aldeia Esquecida que Parece um Conto de Fadas (Meitriz)" },
      { id: "zSp6Gz9DtAg", title: "A Lagoa Secreta e o Castelo Destruído do Gerês" },
      { id: "0yIGfHkAIc0", title: "Paraíso Escondido: O Túnel que Leva à Lagoa Mais Secreta de Portugal!" },
      { id: "1jwHUSlSpTA", title: "O Gerês que Ninguém Vê: 5 Dias em Casas Abandonadas e Trilhos Selvagens" },
      { id: "U_YnFmZQ0IA", title: "Ilhas Cíes: O Segredo Mais Bem Guardado a 1 Hora de Portugal" },
    ],
  },
];

export const SERVICES = [
  {
    code: "01",
    name: "Conteúdo de Marca",
    description:
      "Esquecemos o guião publicitário tradicional para contar histórias onde a sua marca é a protagonista da jornada. Criamos conteúdo narrativo dentro dos universos Viver na Aldeia e Trilhos em Fúria — sem cortes artificiais, focado na verdade e na utilidade real.",
  },
  {
    code: "02",
    name: "Teste de Campo & Integração",
    description:
      "Muito mais do que um product placement. Posicionamos o seu produto no contexto extremo para o qual foi desenhado — seja no esforço de uma subida ao Gerês ou no rigor de um restauro DIY em pedra. Validamos a performance com a autoridade de quem vive o terreno.",
  },
  {
    code: "03",
    name: "Produção Audiovisual de Elite",
    description:
      "Oferecemos uma estética documental e cinematográfica. Utilizamos tecnologia de ponta — drone 4K, estabilização avançada e banda sonora premium — para garantir que a identidade visual da sua marca se destaca com uma qualidade de imagem superior.",
  },
  {
    code: "04",
    name: "Consultoria de Ecossistema YouTube",
    description:
      "Partilhamos a experiência de quem construiu uma comunidade de milhares de seguidores do zero. Ajudamos marcas a navegar no YouTube, desde a estratégia de retenção à criação de uma narrativa que gera confiança e conversão duradoura.",
  },
];

export const BRANDS = [
  "Barbot", "Einhell", "Allpowers", "Reolink",
  "Touroll", "Bluetti",
];
